// Arbitrary fixed offset folded into the visit count before deriving the
// rotation steps, so the overlay doesn't sit at rotation 0 for visit count 0.
// no reason whatsoever for this to be here.
export const VISIT_COUNT_OFFSET = 8647n

export function overlayRotationSteps(visitCount, overlayCount) {
  const count = BigInt(visitCount) + VISIT_COUNT_OFFSET
  const degrees = []
  for (let place = overlayCount - 1; place >= 0; place--) {
    const digit = Number((count / 12n ** BigInt(place)) % 12n)
    degrees.push(digit * 30)
  }
  return degrees
}
